import BracketExplorer from '@/components/triumph/brackets/BracketExplorer'
import BracketMatchup from '@/components/triumph/brackets/BracketMatchup'
import Rewards from '@/components/triumph/Rewards'
import Drawer from '@/components/Drawer'
import SvgLib from '@/components/SvgLib'
import LightSources from '@/components/LightSources'
import MobileDrawerButton from '@/components/MobileDrawerButton'
import OutlineButton from '@/components/OutlineButton'

export default {
  data () {
    return {
      modalActive: false
    }
  },
  components: { BracketExplorer, BracketMatchup, Rewards, Drawer, SvgLib, LightSources, MobileDrawerButton, OutlineButton }
}



// WEBPACK FOOTER //
// ./src/mixins/TriumphDayMixin.js